import { DISPLAY_LANG } from '../../config';
import { Link } from 'react-router-dom';
import './cookies-modal.css';

const pageData = {
    en: {
        title: "We use cookies",
        text: `DOTiGO uses necessary cookies to ensure the secure and proper operation of the website. With your consent, we may also use functional, analytics, and advertising cookies to improve the website, analyse traffic, and provide more relevant content. You can accept all cookies, reject non-essential cookies, or customise your preferences. You may change your preferences at any time through “Cookie Settings”.`,
        btns: 'Accept all/Reject non-essential',
        policyText: 'Cookie Policy',
    },
    ru: {
        title: "Мы используем cookie-файлы",
        text: `DOTiGO использует необходимые cookie-файлы для безопасной и корректной работы сайта. С вашего согласия мы также можем использовать функциональные, аналитические и рекламные cookie-файлы, чтобы улучшать работу сайта, анализировать посещаемость и показывать более релевантный контент. Вы можете принять все cookie-файлы, отклонить необязательные cookie-файлы или настроить свой выбор. Изменить настройки можно в любое время через раздел «Настройки cookie».`,
        btns: 'Принять все/Отклонить необязательные',
        policyText: 'Политика в отношении файлов cookie',
    },
    am: {
        title: "Մենք օգտագործում ենք cookie ֆայլեր",
        text: `DOTiGO-ն օգտագործում է անհրաժեշտ cookie ֆայլեր՝ կայքի անվտանգ և պատշաճ աշխատանքն ապահովելու համար։ Ձեր համաձայնությամբ մենք կարող ենք օգտագործել նաև ֆունկցիոնալ, վերլուծական և գովազդային cookie ֆայլեր՝ կայքի աշխատանքը բարելավելու, այցելությունների վիճակագրությունը վերլուծելու և ավելի համապատասխան բովանդակություն ցուցադրելու նպատակով։ Դուք կարող եք ընդունել բոլոր cookie ֆայլերը, մերժել ոչ պարտադիր cookie ֆայլերը կամ կարգավորել ձեր ընտրությունը։ Ձեր ընտրությունը կարող եք ցանկացած պահի փոխել «Cookie կարգավորումներ» բաժնում։`,
        btns: 'Ընդունել բոլորը/Մերժել ոչ պարտադիրը',
        policyText: 'Cookie քաղաքականությունը',
    },
};

export default function ModalCookies({ setCookiesAccepted }) {
    const handleAcceptCookies = () => {
        localStorage.setItem('cookies_accepted', true);
        setCookiesAccepted(true);
    }

    const handleRejectCookies = () => {
        localStorage.setItem('cookies_accepted', true);
        setCookiesAccepted(true);
    }

    return (
        <>
            <div className="cookie-bg"></div>
            <div className="cookies-modal">
                <img src="/images/cookies/cookie.png" alt="cookie" />
                <h2>{pageData[DISPLAY_LANG].title}</h2>
                <p>{pageData[DISPLAY_LANG].text}</p>
                <Link to="/privacy-policy" className="cookies-modal__policy">
                    {pageData[DISPLAY_LANG].policyText}
                </Link>

                <div className="cookies-modal__btns">
                    <button className="cookies-modal__btns-accept" onClick={handleAcceptCookies}>
                        {pageData[DISPLAY_LANG].btns.split('/')[0]}
                    </button>
                    <button className="cookies-modal__btns-reject" onClick={handleRejectCookies}>
                        {pageData[DISPLAY_LANG].btns.split('/')[1]}
                    </button>
                </div>
            </div>
        </>
    )
}
